import { defineStore } from "pinia";
import {
  findManyProductsByIds,
  getProductPreSalePercentage,
  getProducts,
  // getProductsStocksByIds,
  getRecommendedProductIds,
  getReleaseProducts,
  getSuggestions as getSuggestionsHttp,
} from "../api/products";
import { useCartStore } from "./CartStore";
import { REDIS_KEYS } from "~~/shared/utils/redisKeys";
// import { useUserStore } from "./UserStore";
import { useCategoryStore } from "./CategoryStore";

export const useProductStore = defineStore("product", () => {
  const cartStore = useCartStore();
  // const userStore = useUserStore();
  const cateDatagoryStore = useCategoryStore();
  // const cldUser = computed(() => userStore.cldUser);
  const products = useState("search-product", () => []);
  const productPending = useState("pending-product", () => false);
  const range = useState("range", () => 30);

  // lightweight mini-search results (do NOT reuse 'search-product' to avoid SSR/search page interference)
  const miniSearchProducts = useState("mini-search-products", () => []);
  const miniSearchPending = useState("pending-mini-search-products", () => false);

  const associationsProducts = ref([]);
  const recentlyViewedIds = ref([]);
  const recentlyViewed = ref([]);
  const cartProducts = ref({});
  const promoProducts = ref([]);
  const welcomProducts = ref({});
  // Personalized "Recommended for you" — per-customer, so deliberately kept out of
  // welcomProducts and its shared Redis cache (that key is global across users).
  const recommendedProducts = ref([]);
  const product = ref({});
  const responseKeyword = ref("");

  const suggestions = ref([]);
  const preSalePercentage = ref(0);
  const productsPreSalePercentage = ref({});
  const backOrders = ref({});
  const attributeFilters = useState("attribute-filter", () => ({})); // ref({});
  const productsCount = useState("products-count", () => 0);
  const pageCount = useState("pg-count", () => 0);

  const timeoutId = ref();
  const stocksKV = ref({});
  const loading = ref(false);
  const productsDistinctCategory = ref({ 1: {}, 2: {}, 3: {} });
  const addViewedItem = async (productId) => {
    const index = recentlyViewedIds.value.indexOf(productId);
    if (index !== -1) {
      // Remove the product from its current position
      recentlyViewedIds.value.splice(index, 1);
    } else if (recentlyViewedIds.value.length >= 10) {
      // If already 10 products, remove the oldest one (from the end)
      recentlyViewedIds.value.pop();
    }
    // Add the productId to the beginning of the viewed products list
    recentlyViewedIds.value.push(productId);
  };
  const getCartProducts = async ({ selectedLanguage, ids }) => {
    if (ids.length) {
      const data = await findManyProductsByIds({
        ids: ids,
        selectedLanguage,
        params: "productsForCart",
      });
      if (data.value && data.value.products && data.value.products.length) {
        cartProducts.value = {
          ...Object.assign(
            {},
            ...data.value.products.map((x) => {
              return {
                [x.Identifier]: { ...x },
              };
            })
          ),
        };
      }
    }
  };
  const fetchViewedProducts = ({ selectedLanguage, id }) => {
    setTimeout(async () => {
      const ids = recentlyViewedIds.value.filter((x) => x !== id);
      if (ids.length) {
        const data = await findManyProductsByIds({
          ids: ids,
          selectedLanguage,
          params: "RecentlyViewedProducts",
        });

        if (data.value && data.value.products && data.value.products.length) {
          recentlyViewed.value = data.value.products;
          // if (key) {
          //   const key = cldUser.value?.Id
          //     ? `recently_viewed_products_ip${cldUser.value?.Id}`
          //     : null;
          //   if (key) {
          //     getRedis(key).then((fromCache) => {
          //       if (fromCache && fromCache?.length) {
          //         recentlyViewed.value = fromCache;
          //       }
          //     });
          //   }
          //   setRedis({
          //     key: key,
          //     value: data.value.products,
          //   }).then();
          // }
        }
      }
    }, 1000);
  };
  const fetchReleasedProducts = async ({
    releaseFilters,
    startRowIndex,
    range,
    selectedLanguage,
    sortOrder,
  }) => {
    loading.value = true;
    const {
      products: _products,
      success: isSuccess,
      attributeFilters: _attributeFilters,
      productsCount: _productsCount,
      pageCount: _pageCount,
    } = await getReleaseProducts({
      releaseFilters,
      startRowIndex,
      range,
      selectedLanguage,
      sortOrder,
    });
    console.log("data for released products", _products);

    loading.value = false;
    if (isSuccess) {
      products.value = _products;
      attributeFilters.value = _attributeFilters;
      productsCount.value = _productsCount;
      pageCount.value = _pageCount;
    }
    return _products;
  };
  // Elasticsearch returns each Categories_agg bucket with a `parent_top_hits`
  // sub-aggregation carrying a full `Values.category_tree` document `_source` —
  // at all three nesting levels. Nothing on the search page reads it
  // (CategoryFilters.vue only uses key/doc_count/child_agg/sub_child_agg; the
  // labels come from categoryLables, built off fullCategoryFilters instead), but
  // both this store and the useAsyncData cache holding the raw response are
  // serialized into __NUXT_DATA__, which made the SSR document for
  // /products/search 7.4 MB — 94% of it this one unread field.
  //
  // The backend no longer requests parent_top_hits for product search
  // (cld-node/be products.queries.ts), but this stays as the client-side
  // guarantee so the payload is small against any API version. Projecting an
  // already-slim bucket is a no-op.
  const projectCategoryBuckets = (buckets) => {
    if (!Array.isArray(buckets)) return [];
    return buckets.map((parent) => ({
      key: parent.key,
      doc_count: parent.doc_count,
      child_agg: {
        buckets: (parent.child_agg?.buckets || []).map((child) => ({
          key: child.key,
          doc_count: child.doc_count,
          sub_child_agg: {
            buckets: (child.sub_child_agg?.buckets || []).map((sub) => ({
              key: sub.key,
              doc_count: sub.doc_count,
            })),
          },
        })),
      },
    }));
  };

  const checkAggregations = async ({ aggregations, count, range }) => {

    if (aggregations) {
      const customAggregations = {
        ...aggregations,
        in_stock: {
          buckets: [
            {
              key: 1,
              key_as_string: "true",
              doc_count: " ", // "> 0"
              custome_boolean_filter: true,
            },
          ],
        },
        in_reserved: {
          buckets: [
            {
              key: 1,
              key_as_string: "true",
              doc_count: " ", // "> 0"
              custome_boolean_filter: true,
              auth: true,
            },
          ],
        },
      };
      attributeFilters.value = customAggregations;
      delete attributeFilters.value["Categories_agg"];
    }
  };
  const setAttributeFilters = (value) => {
    attributeFilters.value = value;
  };
  
  let abortCtrl = null;
  let miniAbortCtrl = null;
  let activeProductsRequestId = 0;

  const clearMiniSearchProducts = () => {
    miniSearchProducts.value = [];
  };

  const fetchMiniSearchProducts = async ({
    prefix = "",
    selectedLanguage,
    range: _range = 10,
    startRowIndex = 1,
  } = {}) => {
    const q = String(prefix || "").trim();
    if (q.length < 2) {
      if (miniAbortCtrl) {
        try {
          miniAbortCtrl.abort();
        } catch (e) {}
      }
      clearMiniSearchProducts();
      miniSearchPending.value = false;
      return miniSearchProducts.value;
    }

    miniSearchPending.value = true;
    const url = useURLs[NODE_ENV].PRODUCT_SEARCH_URL;

    if (miniAbortCtrl) {
      try {
        miniAbortCtrl.abort();
      } catch (e) {}
    }
    miniAbortCtrl = new AbortController();

    // Minimal payload: products only
    const payload = JSON.stringify({
      prefix: q,
      range: _range,
      startRowIndex,
      filters: { attribute: {}, categories: [], release: {} },
      selectedLanguage,
      sortOrder: "",
      searchByMultiIds: { active: false, ids: [] },
    });

    try {
      const isAuthRequire = !!useCookie("isAuthenticated").value;
      const { data } = await useFetchApi(
        url,
        {
          // key intentionally *not* stable across different queries
          key: `mini:${selectedLanguage}:${q}:${_range}:${startRowIndex}:auth-${isAuthRequire}`,
          method: "POST",
          body: payload,
          signal: miniAbortCtrl.signal,
          headers: {
            client_id: useURLs[NODE_ENV].CLIENT_ID,
            client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
            "Content-Type": "application/json",
          },
          // no aggregations/count needed
          pick: ["products"],
          dedupe: "cancel",
          // never run this on SSR; mini-search is an interactive UI only
          server: false,
        },
        isAuthRequire
      );

      miniSearchProducts.value = data.value?.products || [];
      return miniSearchProducts.value;
    } catch (error) {
      // swallow abort errors and keep UI responsive
      console.warn("fetchMiniSearchProducts error:", error);
      miniSearchProducts.value = [];
      return miniSearchProducts.value;
    } finally {
      miniSearchPending.value = false;
    }
  };
  const fetchProducts = async (payload) => {
    const requestId = ++activeProductsRequestId;
    productPending.value = true;
    const url = useURLs[NODE_ENV].PRODUCT_SEARCH_URL;

    // const payload = JSON.stringify({
    //   prefix: prefix,
    //   range: range,
    //   startRowIndex: startRowIndex,
    //   filters: filters,
    //   selectedLanguage,
    //   sortOrder: sortOrder,
    //   searchByMultiIds,
    //   ...{ ...((priceMin > 1 || priceMax < 9999) && { priceMin, priceMax }) },
    // });
    if (abortCtrl) {
      try {
        abortCtrl.abort(); // cancel previous request
      } catch (e) {}
    }

    abortCtrl = new AbortController();

    try {
      // const token = useCookie('authToken').value
      const isAuthRequire = !!useCookie("isAuthenticated").value;
      const { data, error, pending } = await useFetchApi(
        url,
        {
          key: `${payload}:auth-${isAuthRequire}`,
          method: "POST",
          body: payload,
          signal: abortCtrl.signal,
          headers: {
            client_id: useURLs[NODE_ENV].CLIENT_ID,
            client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
            "Content-Type": "application/json",
          },
          retry: 1,
          // Runs before Nuxt caches/serializes the result, so the heavy
          // parent_top_hits never reaches __NUXT_DATA__. Doing this only where the
          // store reads the buckets would not have helped: useAsyncData serializes
          // the raw response under this key too.
          transform: (res) => {
            const buckets = res?.aggregations?.Categories_agg?.buckets;
            if (!Array.isArray(buckets)) return res;
            return {
              ...res,
              aggregations: {
                ...res.aggregations,
                Categories_agg: {
                  ...res.aggregations.Categories_agg,
                  buckets: projectCategoryBuckets(buckets),
                },
              },
            };
          },
          pick: [
            "products",
            "count",
            "aggregations",
            // "categoryLabels",
            // "keywords",
          ],
          dedupe: "cancel",
        },
        isAuthRequire
      );
      // console.error("Errr fetching products", error.value);
      // responseKeyword.value = data.value?.keywords || "";
      // if (data.value && data.value?.products) {
      // Only the latest request may update state
      if (requestId !== activeProductsRequestId) return true;

      products.value = data.value?.products || [];
      productsCount.value = data.value?.count || 0;
      pageCount.value = Math.ceil(productsCount.value / range.value);
      // }
      try {
        // if (data.value?.categoryLabels) {
        //   productsDistinctCategory.value = data.value.categoryLabels;
        // }

        cateDatagoryStore.setCategoryFilters(
          projectCategoryBuckets(data.value.aggregations.Categories_agg.buckets)
        );
        checkAggregations({
          aggregations: data.value?.aggregations,
          range,
          count: data.value?.count,
        }).then((x) => x);
      } catch (error) {
        // Aggregation parsing failed, but products are still loaded
      }
    } catch (error) {
      // Request failed or was aborted
      const isAbort =
        error?.name === "AbortError" ||
        error?.cause?.name === "AbortError" ||
        /aborted|aborterror|cancell?ed/i.test(String(error));

      // If a newer request started, ignore this one completely.
      if (requestId !== activeProductsRequestId) return true;

      if (!isAbort) {
        console.error("fetchProducts error:", error);
      }
    } finally {
      // Only the latest request may clear pending.
      if (requestId === activeProductsRequestId) {
        productPending.value = false;
      }
    }
    return true;
  };
  const checkAssociationsInBackground = async () => {
    associationsProducts.value = [];

    if (
      product.value &&
      product.value?.associations &&
      product.value.associations.X_SELL.Products &&
      product.value.associations.X_SELL.Products.length
    ) {
      const associationsxSellIds = product.value.associations.X_SELL.Products;
      findManyProductsByIds({
        ids: associationsxSellIds,
        selectedLanguage,
        params: "associationsProducts",
      }).then((data) => {
        if (data.value && data.value.products && data.value.products.length) {
          associationsProducts.value = data.value.products;
        }
      });
    }
  };
  const fetchProduct = async ({ id, selectedLanguage }) => {
    try {
      product.value = {};

      const url = `${useURLs[NODE_ENV].PRODUCT_FIND_URL}?id=${id}&selectedLanguage=${selectedLanguage}`;

      loading.value = true;
      const isAuthRequire = !!useCookie("isAuthenticated").value;
      const { data } = await useFetchApi(
        url,
        {
          key: `id=${id}&selectedLanguage=${selectedLanguage}`,
          method: "GET",
          headers: {
            client_id: useURLs[NODE_ENV].CLIENT_ID,
            client_secret: useURLs[NODE_ENV].CLIENT_SECERET,
            "Content-Type": "application/json",
          },
          retry: 2,
        },
        isAuthRequire
      );
      if (data.value && data.value["product"]) {
        product.value = data.value["product"];
        loading.value = false;
      }
      checkAssociationsInBackground();
      return data.value["product"];
    } catch (error) {
      console.error("Error fetching product info", error);
    }
  };
  const fetchWelcomeProductsWithFilters = async ({
    selectedLanguage,
    range = 15,
    startRowIndex = 1,
    categories = [],
    attribute,
    key,
    sortOrder = "stock_rank_desc",
  }) => {
    const { products: _products, success } = await getProducts(
      {
        sortOrder,
        filterInput: "",
        range,
        startRowIndex,
        selectedFilters: {
          categories,
          attribute,
        },
        selectedLanguage,
      },
      `welcome-products-${key}`
    );
    loading.value = false;

    if (success) {
      welcomProducts.value[key] = _products;
    }
  };
  // "Recommended for you": ranked ids from the core API (nightly per-customer
  // snapshot), resolved through the Node search API so market/pricing visibility
  // applies. Ids that don't resolve (out of stock, not visible for this customer)
  // are silently dropped — the id list is over-fetched to compensate.
  const fetchRecommendedProducts = async ({ selectedLanguage }) => {
    const ids = await getRecommendedProductIds(50);
    if (!ids.length) {
      recommendedProducts.value = [];
      return;
    }

    const data = await findManyProductsByIds({ ids, selectedLanguage });
    const resolved = data?.value?.products ?? [];

    // findManyProductsByIds does not guarantee order — restore recommendation rank.
    const rankById = new Map(ids.map((id, i) => [String(id), i]));
    recommendedProducts.value = resolved
      .slice()
      .sort(
        (a, b) =>
          (rankById.get(String(a.Identifier)) ?? Infinity) -
          (rankById.get(String(b.Identifier)) ?? Infinity)
      );
  };
  const fetchPromoProducts = async ({
    selectedLanguage,
    range = 15,
    startRowIndex = 1,
  }) => {
    const { products: _promoProducts, success } = await getProducts(
      {
        sortOrder: "stock_desc",
        filterInput: "",
        range,
        startRowIndex,
        selectedFilters: {
          categories: [],
          attribute: {
            price_promo: {
              "price promo": true,
            },
          },
        },
        selectedLanguage,
      },
      "promo-products"
    );
    loading.value = false;
    promoProducts.value = [];

    if (success) {
      promoProducts.value = _promoProducts;
    }
  };
  const getBackOrders = async ({ skus }) => {
    const isAuthenticated = useCookie("isAuthenticated").value;
    if (!isAuthenticated) {
      return false;
    }
    const url = useCldURLs[CLD_ENV].product.get_back_orders;

    const { data } = await useFetchApi(url, {
      method: "POST",
      key: `${skus.join(",")}`,
      body: { Skus: skus.slice(-100) },
      headers: {
        "Content-Type": "application/json",
      },
    });

    return data;
  };
  const getBackOrdersCldWebApi = async ({ skus }) => {
    if (!skus.length) return;

    const newBackOrders = await getBackOrders({
      skus,
    });

    if (newBackOrders.value?.data) {
      backOrders.value = {
        ...backOrders.value,
        ...newBackOrders.value.data,
      };
    }
  };
  const handleBackOrders = async (skus) => {
    if (skus.length) {
      clearTimeout(timeoutId.value);
      timeoutId.value = setTimeout(async () => {
        // filtering to make sure that backOrder is not already caculated
        // const skus = products.value
        //   .filter((e) => !backOrders.value[e.Identifier])
        //   .map((x) => x.Identifier);

        await getBackOrdersCldWebApi({ skus });
      }, 3000);
    }
  };
  const handleWelcomeProductsBackOrders = async () => {
    if (Object.keys(welcomProducts.value).length) {
      const allProducts = Object.values(welcomProducts.value).flat();
      if (!allProducts.length) {
        return;
      }

      setTimeout(async () => {
        const skus = allProducts
          .map((x) => x.Identifier)
          .filter((e) => !backOrders.value[e]);
        await getBackOrdersCldWebApi({ skus });
      }, 0);
    }
  };
  const refillWelcomeProductsFromRedis = async () => {
    const fromCache = await getRedis("welcomProducts");
    if (fromCache) {
      welcomProducts.value = fromCache;
    }
  };
  const setWelcomeProductsToRedis = async () => {
    setRedis({
      key: "welcomProducts",
      value: welcomProducts.value,
    }).then(() => console.log("welcomProducts settled in cache"));
  };
  const getSuggestions = async (keyword) => {
    if (keyword?.length < 3) {
      return;
    }
    const chainId = cartStore.sessionData["ChainId"];
    const data = await getSuggestionsHttp({ keyword, chainId });
    suggestions.value = data;
  };
  const resetProducts = () => {
    products.value = [];
  };

  const getProductPreSalePercentageCld = async (id) => {
    const fromCache = await getRedis(
      REDIS_KEYS.PRESALE_PERCENTAGE
    );

    if (fromCache && Object.keys(fromCache).length && fromCache[id]) {
      preSalePercentage.value = fromCache[id];
      return;
    }
    const data = await getProductPreSalePercentage(id);
    if (data <= 0) {
      return;
    }
    // console.log("data for getProductPreSalePercentageCld " + id, data);
    preSalePercentage.value = data.value;
    productsPreSalePercentage.value = {
      ...productsPreSalePercentage.value,
      [id]: data.value,
    };
    setRedis({
      key: REDIS_KEYS.PRESALE_PERCENTAGE,
      value: productsPreSalePercentage.value,
    }).then(() => console.log("PRESALE_PERCENTAGE settled in cache"));
  };

  // const fetchProductsStocksByIds = async (ids) => {
  //   const data = await getProductsStocksByIds({ ids });
  //   stocksKV.value = data.ItemsKV;
  // };
  const setProductDetails = (v) => {
    product.value = v;
  };
  const setProductsBackOrders = (v) => {
    backOrders.value = v;
  };
  const setProducts = (v) => {
    products.value = v;
  };
  return {
    backOrders,
    products,
    miniSearchProducts,
    miniSearchPending,
    productsDistinctCategory,
    loading,
    stocksKV,
    product,
    recentlyViewed,
    associationsProducts,
    suggestions,
    attributeFilters,
    productsCount,
    pageCount,
    preSalePercentage,
    promoProducts,
    welcomProducts,
    recommendedProducts,
    fetchRecommendedProducts,
    fetchProducts,
    fetchMiniSearchProducts,
    fetchProduct,
    fetchReleasedProducts,
    // fetchAllFutureReleaseProducts,
    fetchViewedProducts,
    handleBackOrders,
    resetProducts,
    clearMiniSearchProducts,
    getSuggestions,
    getBackOrdersCldWebApi,
    getProductPreSalePercentageCld,
    responseKeyword,
    fetchPromoProducts,
    addViewedItem,
    getCartProducts,
    cartProducts,
    setProductDetails,
    setProducts,
    fetchWelcomeProductsWithFilters,
    refillWelcomeProductsFromRedis,
    setWelcomeProductsToRedis,
    setProductsBackOrders,
    handleWelcomeProductsBackOrders,
    checkAggregations, // delete this
    setAttributeFilters,
 
  };
});
